import { DragDropProvider } from '@dnd-kit/react';
import { isSortable } from '@dnd-kit/react/sortable';
import { Button } from '@mui/material';
import useGetSystemBranchInsert from 'api/branch/useGetSystemBranchData/useGetSystemBranchInsertData';
import { arrayMoveImmutable as arrayMove } from 'array-move';
import { routesMap } from 'components/layout/routes';
import { usePageManager } from 'hooks/pageManager/usePageManager';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useInsertSystemBranch from '../../../api/branch/useInsertSystemBranch/useInsertSystemBranch';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import TryAgain from '../TryAgain/TryAgain';
import { BranchCreateItem } from './BranchCreateItem';

const BranchSystemCreate = ({
  branchGuid,
  originGuid,
  onEditComplete,
  createMode = false,
  profileGuid,
}) => {
  const {
    getBranchInsert: getData,
    getBranchInsertData: data,
    setGetBranchInsertData: setData,
    getBranchInsertError: getError,
    getBranchInsertLoading: getLoading,
  } = useGetSystemBranchInsert(createMode);

  const {
    insertSystemBranch: insert,
    insertSystemBranchLoading: insertLoading,
  } = useInsertSystemBranch(createMode);

  const { refreshTabById } = usePageManager();

  const { guid } = useParams();

  useEffect(() => {
    if (createMode && !profileGuid) return;

    if (!createMode && branchGuid === null) return;

    getData({ branchGuid, originGuid, profileGuid });
  }, [branchGuid, createMode, getData, originGuid, profileGuid]);

  const navigate = useNavigate();

  const productDetailRoute = routesMap.get('/productDetail/:guid');

  const hasFilledValue = data?.value
    ? data.value?.find(
        d =>
          d.selectedValue?.value?.length &&
          d.selectedValue?.value !== 'هیچکدام',
      )
    : false;

  function handleSubmit() {
    if (hasFilledValue) {
      const submitData = {
        values: data.value.map(i => ({
          guid: i.guid,
          selectedValue: i.selectedValue?.key,
          showInDisplay: !!i.showInDisplay,
        })),
      };

      if (!!guid && !branchGuid && !createMode) {
        submitData.originGuid = guid;
        insert(false, submitData, () => {
          refreshTabById(productDetailRoute.id);
          navigate(`/productDetail/${guid}`);
        });
      } else {
        submitData.guid = branchGuid;
        if (createMode) {
          submitData.branchGuid = branchGuid;
          submitData.originGuid = originGuid;
          submitData.profileGuid = profileGuid;
        }
        insert(true, submitData, () => onEditComplete());
      }
    }
  }

  const onDragEnd = ({ oldIndex, newIndex }) => {
    try {
      if (oldIndex === newIndex) return;

      setData(oldData => {
        oldData.value = arrayMove(oldData.value, oldIndex, newIndex);

        return { ...oldData };
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleDragEnd = useCallback(({ canceled, operation }) => {
    if (canceled) {
      return;
    }

    const { source } = operation;

    if (!isSortable(source)) {
      return;
    }

    const { initialIndex, index } = source.sortable;

    if (initialIndex === index) {
      return;
    }

    onDragEnd({
      oldIndex: initialIndex,
      newIndex: index,
    });
  }, []);

  if (getLoading) {
    return <SpinnerLoader />;
  }

  if (getError) {
    return (
      <TryAgain
        tryAgain={() => getData({ branchGuid, originGuid, profileGuid })}
      />
    );
  }

  return (
    <DragDropProvider onDragEnd={handleDragEnd}>
      {data?.value?.map((item, index) => (
        <BranchCreateItem
          key={item.guid}
          index={index}
          item={item}
          setData={setData}
        />
      ))}
      {/* <DragDropProvider>
        <Droppable droppableId="0">
          {(provided, snapshot) => (
            <DroppableContainer
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {data?.value?.map((card, index) => (
                <Draggable
                  key={card.guid}
                  draggableId={`${card.guid}`}
                  index={index}
                >
                  {(provided1, s) => (
                    <div
                      ref={provided1.innerRef}
                      {...provided1.draggableProps}
                      {...provided1.dragHandleProps}
                      style={getItemStyle(
                        s.isDragging,
                        provided1?.draggableProps?.style,
                      )}
                    >
                      <Card setData={setData} key={card.guid} card={card} />
                    </div>
                  )}
                </Draggable>
              ))}
            </DroppableContainer>
          )}
        </Droppable>
      </DragDropProvider> */}

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        sx={{
          m: 'auto',
          display: 'block',
          my: '20px',
          maxWidth: '120px',
        }}
        fullWidth
        disabled={getLoading || insertLoading || !hasFilledValue}
        size="large"
      >
        ثبت
      </Button>
    </DragDropProvider>
  );
};

export default BranchSystemCreate;
